<template>
  <div>
    <template v-if="isString(type) || isInteger(type) || isDecimal(type)">
      <Textfield v-bind="{...$attrs, ...textFieldAttrs}" v-on="$listeners">
        <slot></slot>
      </Textfield>
    </template>
    <template v-if="isBoolean(type)">
      <Autocomplete
        v-bind="{...$attrs, ...autocompleteAttrs}"
        v-on="$listeners"
        :items="[
          {id: true, name: 'Sim'},
          {id: false, name: 'Não'}
        ]"
        item-text="name"
        item-value="id">
        <slot></slot>
      </Autocomplete>
    </template>
    <template v-if="isList(type)">
      <Autocomplete v-bind="{...$attrs, ...autocompleteAttrs}" v-on="$listeners">
        <template v-slot:selection="{ item, index }">
          <div
            class="d-flex flex-row">
            <v-chip v-if="index < 1">
              <TextBase textSm>
                {{ convertText(item.description) }}
              </TextBase>
            </v-chip>
            <TextBase textSm
              v-if="index === 1"
              class="foreground--text text-caption">
              {{
                formatter.getPluralText(
                  "outra",
                  $attrs.value
                )
              }}
            </TextBase>
          </div>
        </template>
      </Autocomplete>
    </template>
  </div>
</template>
<script>
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import Autocomplete from '@/components/Default/Autocomplete.vue';
import Textfield from '@/components/Default/Textfield.vue';
import Formatters from '@/shared/formatters/formatters';
import InvoiceParameterText from './InvoiceParameterText.vue';
import { is } from 'date-fns/locale';
export default {
  name: "InvoiceParameterInput",
  data: () => ({
    formatter: new Formatters(),
  }),
  components: {
    TextBase: InvoiceParameterText,
    Autocomplete,
    Textfield,
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  props: {
    type: {
      required: true,
    }
  },
  computed: {
    ruleType() {
      switch (this.type) {
        case "STRING":
          return "STRING";
        case "INTEGER":
          return "INTEGER";
        case "DECIMAL":
          return "DECIMAL";
        case "BOOLEAN":
          return "BOOLEAN";
        default:
          // when default: key has options (combo box)
          return "LIST";
      }
    }
  }
}
</script>